/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { StationPolicy } from 'client-code/channels-service';
import { TServicesParams } from '../types/TServicesParams';
import { IStationPolicyServiceRepository } from '../interfaces/IStationPolicyServiceRepository';
import { StationPolicyServiceRepositoryImpl } from '../impls/StationPolicyServiceRepositoryImpl';

export class StationPolicyService implements IStationPolicyServiceRepository {
    private oStationPolicyServiceRepositoryImpl: StationPolicyServiceRepositoryImpl;

    constructor(params: TServicesParams) {
        this.oStationPolicyServiceRepositoryImpl = new StationPolicyServiceRepositoryImpl(params);
    }

    async fetchStationPolicies(): Promise<Array<StationPolicy>> {
        return this.oStationPolicyServiceRepositoryImpl.fetchStationPolicies();
    }
}
